module.exports = __webpack_public_path__ + "fonts/Prompt-ExtraLight.cec66179.ttf";